
<script>
import moment from 'moment'

export default {
  name: 'rex-rounded-date',
  props: {
    label: {
      type: String,
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => '',
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    position: {
      type: String,
      default: () => null
    },
    minDate: {
      type: Date,
      default: () => moment().toDate()
    },
    maxDate: {
      type: Date,
      default: () => moment().add(5, 'years').toDate()
    },
    placeholder: {
      type: String,
      default: () => 'Выберите дату'
    },
    range: {
      type: Boolean,
      default: () => false
    },
    rangeStartDateName: {
      type: String,
      default: () => 'startDate'
    },
    rangeEndDateName: {
      type: String,
      default: () => 'endDate'
    },
    marks: {
      type: Array,
      default: () => []
    },
    legend: {
      type: Array,
      default: () => []
    },
    filledMarks: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    value: {
      get() {
        let date

        if (this.range) {
          const startDate = (
            this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)[this.rangeStartDateName]
          )
          const endDate = (
            this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)[this.rangeEndDateName]
          )

          date = startDate === null || endDate === null
            ? []
            : [
              moment(startDate, 'DD.MM.YYYY').toDate(),
              moment(endDate, 'DD.MM.YYYY').toDate()
            ]
        } else {
          date = this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
          date = date === null
            ? moment().add(3, 'days').toDate()
            : moment(date, 'DD.MM.YYYY').toDate()
        }

        return date
      },
      set(value) {
        if (this.range) {
          let [startDate, endDate] = value
          startDate = moment(startDate).format('DD.MM.YYYY')
          endDate = moment(endDate).format('DD.MM.YYYY')

          this.$store.commit(`${this.storeModule}/${this.setterName}`, {
            target: `${this.target}.${this.rangeStartDateName}`,
            value: startDate
          })
          this.$store.commit(`${this.storeModule}/${this.setterName}`, {
            target: `${this.target}.${this.rangeEndDateName}`,
            value: endDate
          })

          this.$emit('onChange', {
            event: {
              startDate,
              endDate
            },
            element: this.$vnode.elm
          })
        } else {
          this.$store.commit(`${this.storeModule}/${this.setterName}`, {
            target: this.target,
            value: moment(value).format('DD.MM.YYYY')
          })

          this.$emit('onChange', {
            event: moment(value).format('DD.MM.YYYY'),
            element: this.$vnode.elm
          })
        }
      }
    }
  }
}
</script>
<template>
  <div
    v-if="value"
    :class="cssClass"
    class="rex-rounded-field"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field--label"
    >
      {{ label }}
    </h3>
    <b-field>
      <b-datepicker
        v-model="value"
        class="rex-rounded-date"
        :class="{
          'rex-rounded-date--filled-marks': filledMarks
        }"
        :placeholder="placeholder"
        :min-date="minDate"
        :max-date="maxDate"
        :disabled="disabled"
        :position="position"
        :range="range"
        :events="marks"
        indicators="bars"
      >
        <div
          v-for="(item, index) in legend"
          :key="index"
          class="rex-rounded-date__legend-item"
        >
          <div
            class="rex-rounded-date__legend-item-color"
            :style="{
              'background-color': item.color
            }"
          />
          <p class="rex-rounded-date__legend-item-label">
            {{ item.label }}
          </p>
        </div>
      </b-datepicker>
    </b-field>
  </div>
</template>
